<template>
  <div class="attribute" :class="{ 'without-margin': selectedStore && selectedStore.stock <= 0 }">
    <div class="attr-label"><p>{{ label }}</p></div>
    <div class="attr-items">
      <div class="providers" v-if="providers">
        <div class="item" :class="{ 'active' : (selectedProvider && selectedProvider.code === provider.code) }" @click.prevent="selectProvider(provider)" v-for="(provider, index) in providers" :key="index">
          <img :src="provider.logo.url" :alt="provider.logo.alt" v-if="provider.logo">
          <span v-else>{{ provider.name }}</span>
        </div>
      </div>
      <SubscriptionSlider v-if="subscriptions.length" :subscriptions="subscriptions" :selected="modelValue" @change="selectSubscription"/>
    </div>
  </div>
</template>

<script>
import SubscriptionSlider from '../SubscriptionSlider'

import { mapState, mapActions } from 'vuex'

export default {
  name: 'Subscription',
  props: {
    modelValue: Object,
    label: String
  },
  data () {
    return {
      selectedProvider: null
    }
  },
  mounted () {
    this.providers.forEach((provider) => {
      if(!this.phone.defaults.subscription && provider.code === 'alone') {
        this.selectedProvider = provider
      } else if(this.phone.defaults.subscription && provider.code === this.phone.defaults.subscription.operateur.id){
        this.selectedProvider = provider
      }
    })
  },
  computed: {
    ...mapState({
      selectedCode: state => state.stores.selected,
      stores: state => state.stores.items,
      sourceProviders: state => state.providers.items,
      phone: state => state.phone.item,
      loading: state => state.phone.loading
    }),
    providers () {
      const providers = []
      const sorted = this.groupBy(this.phone.subscriptions, subscription => subscription.operateur.id)

      sorted.forEach((subscription, key) => {
        this.sourceProviders.forEach((provider) => {
          if(provider.id === key){
            providers.push({
              code: key,
              name: provider.name,
              logo: provider.logo,
              subscriptions: subscription
            })
          }
        })
      })

      providers.push({
        code: 'alone',
        name: 'Sans forfait',
        subscriptions: []
      })

      return providers.sort((a,b)=> (a.name > b.name ? 1 : -1))
    },
    subscriptions() {
      let subscriptions = []
      if(this.selectedProvider && this.selectedProvider.subscriptions.length) subscriptions = this.selectedProvider.subscriptions
      return subscriptions
    },
    selectedStore () {
      let selectedStore = null

      this.stores.forEach((store) => {
        if(store.code === this.selectedCode) {
          selectedStore = store
        }
      })

      return selectedStore
    }
  },
  methods: {
    groupBy(list, keyGetter) {
      const map = new Map();
      list.forEach((item) => {
        const key = keyGetter(item);
        const collection = map.get(key);
        if (!collection) {
          map.set(key, [item]);
        } else {
          collection.push(item);
        }
      });
      return map;
    },
    selectProvider (provider) {
      this.selectedProvider = provider

      if(provider.code === 'alone'){
        this.$emit('change-provider', false)
        this.$emit('change')
      } else {
        this.$emit('change-provider', true)
        this.$emit('update:modelValue', (provider.subscriptions.length) ? provider.subscriptions[0] : null)
        this.$emit('change')
      }

    },
    selectSubscription (subscription) {
      this.$emit('update:modelValue', subscription)
      this.$emit('change')
    }
  },
  watch: {
    providers () {
      this.providers.forEach((provider) => {
        if(!this.phone.defaults.subscription && provider.code === 'alone') {
          this.selectedProvider = provider
        } else if(this.phone.defaults.subscription && provider.code === this.phone.defaults.subscription.operateur.id){
          this.selectedProvider = provider
        }
      })
    }
  },
  components: {
    SubscriptionSlider
  }
}
</script>

<style lang="scss" scoped>
@import '../../../../scss/tools/*';
@import '../../../../scss/mixins/*';

.attribute{
  margin-bottom: 20px;

  &.without-margin{
    margin-bottom: 0;
  }

  .attr-label {
    margin-bottom: 15px;

    p {
      font-size: px2rem(15px);
      line-height: px2rem(22px);
      font-weight: $fontRegular;
    }
  }

  .attr-items{
    .item{
      width: auto;
      height: 50px;
      line-height: 28px;
      border: 1px solid darken($white, 10%);
      margin: 0 10px 10px 0;
      position: relative;
      cursor: pointer;
      padding: 10px 15px 10px 15px;
      text-transform: capitalize;
      @include radius(5px);
      @include transition();

      .inner {
        width: auto;
      }

      &:after {
        display: inline-block;
        content: '';
        position: absolute;
        top: -1px;
        left: -1px;
        width: calc(100% - 2px);
        height: calc(100% - 2px);
        border: 2px solid $black;
        opacity: 0;
        @include radius(5px);
        @include transition();
      }

      &:hover {
        &:after {
          opacity: 1;
        }
      }

      &.active {
        color: $primary;

        &:after {
          opacity: 1;
          border: 2px solid $primary;
        }
      }
    }

    .providers{
      .item{
        display: flex;
        align-items: center;
        justify-content: center;
        height: 60px;

        img{
          max-width: 120px;
          max-height: 30px;
          height: auto;
          width: auto;
        }
      }
    }
  }
}
</style>
